import React, { useCallback } from 'react'
import context from '@/context'
import { ValidationBoundary } from '@/components/validation'
import { ModalBody, Row } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { FormLoader, FormRow } from '@/components/changeRequests'
import { ChangeItemDialogFooter } from '@/dialogs/common/changeItemDialogFooter'
import { ChangeItemFileAttachments } from '@/components/changeRequests/fileAttachments'

function LicenseDialog (props) {
  const getAttachmentsTableData = useCallback((req) => context.api.institutionService.getLicenseAttachmentsTableData(props.id, req), [props.id])
  return (
    <FormLoader {...props} render={() =>
      <ValidationBoundary>
        <BasicHeader title='Institutions.License' {...props} />
        <ModalBody>
          <Row>
            <div className='col-12'>
              <FormRow label='Institutions.LicenseType' name='type' target={props.target} inputType='lookup' dataSource={context.cache.getLicenseTypes} clientSide isCodeList required />
              <FormRow label='Institutions.LicenseNumber' name='number' target={props.target} inputProps={{ maxLength: 100 }} required />
              <FormRow label='Institutions.LicenseIssueDate' name='issueDate' target={props.target} inputType='date' required />
            </div>
          </Row>
          <Row>
            <div className='col-12'>
              <ChangeItemFileAttachments
                target={props.target}
                name='attachments'
                dataSource={getAttachmentsTableData}
                downloadAction={context.api.institutionService.downloadLicenseAttachment}
                simpleView
                attachmentsView />
            </div>
          </Row>
        </ModalBody>
        <ChangeItemDialogFooter {...props} />
      </ValidationBoundary>
    } />
  )
}

export default {
  modalProps: {
    size: 'lg'
  },
  component: LicenseDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/license.js